// src/api/axiosConfig.js

import axios from 'axios';
import { serverurl } from './config';

const api = axios.create({
  baseURL: serverurl, // make sure `serverurl` is imported or hardcoded here
  withCredentials: true, // for sending HttpOnly cookies
  headers: {
    'Content-Type': 'application/json',
    // Add default headers here, like Authorization if needed
    // 'Authorization': `Bearer ${token}`
  }
});

export default api;
